import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, shareReplay, switchMap } from 'rxjs';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';
import { GalaxyProgressBarModule } from '@vendasta/galaxy/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { VoiceApiService } from '@vendasta/voice';
import { NamespaceInterface } from '@vendasta/ai-assistants/lib/_internal/interfaces/namespace.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ai-assistant-voice-usage',
  imports: [CommonModule, AiAssistantI18nModule, GalaxyProgressBarModule, MatIconModule, GalaxyTooltipModule],
  templateUrl: './ai-assistant-voice-usage.component.html',
  styleUrls: ['./ai-assistant-voice-usage.component.scss'],
})
export class AiAssistantVoiceUsageComponent {
  namespace = input<NamespaceInterface>();

  protected readonly translationService = inject(TranslateService);
  private readonly voiceApiService = inject(VoiceApiService);

  readonly callUsageLimitMinutes = 300;

  callUsage$ = toObservable(this.namespace).pipe(
    filter((namespace) => !!namespace),
    switchMap((namespace) => this.voiceApiService.getCallUsage({ namespace: namespace })),
    map((r) => {
      // nanoseconds to minutes, rounded down to the nearest minute
      const totalMinutes = Math.floor(r?.totalDuration / 60_000_000_000);
      return {
        totalMinutes: totalMinutes,
        startDate: r?.startTime,
        endDate: r?.endTime,
        limitPercent: Math.min(Math.round((totalMinutes / this.callUsageLimitMinutes) * 100), 100),
      };
    }),
    shareReplay(1),
  );
}
